import { STRENGTH_COPY, type PasswordStrength as Level } from '../../lib/password-strength';
import { cx } from '../../lib/cx';

const FILL: Record<Exclude<Level, 0>, string> = {
  1: 'bg-feedback-error',
  2: 'bg-feedback-warning',
  3: 'bg-feedback-success',
  4: 'bg-feedback-success',
};

export interface PasswordStrengthProps {
  level: Level;
  /** Hide the sentence and show only the bar (the field's own helper text may already say it). */
  barOnly?: boolean;
  className?: string;
}

/** Four-segment meter (Figma "Set new password"). Guidance only; never blocks submit. */
export function PasswordStrength({ level, barOnly = false, className }: PasswordStrengthProps) {
  return (
    <div className={cx('flex flex-col gap-(--mbm-space-2)', className)}>
      <div
        role="meter"
        aria-label="Password strength"
        aria-valuemin={0}
        aria-valuemax={4}
        aria-valuenow={level}
        className="flex gap-(--mbm-space-1-5)"
      >
        {[1, 2, 3, 4].map((segment) => (
          <span
            key={segment}
            className={cx(
              'h-(--mbm-space-1) flex-1 rounded-full',
              segment <= level ? FILL[level as Exclude<Level, 0>] : 'bg-border-default',
            )}
          />
        ))}
      </div>
      {!barOnly && level > 0 ? <p className="text-body-small text-text-tertiary">{STRENGTH_COPY[level]}</p> : null}
    </div>
  );
}
